import React, { Component } from "react";
import { FaPlusCircle } from 'react-icons/fa';

class NewAdminForm extends Component {
    state= {
        addError: {
            state: false,
            message: ""
        },
        profile_photo: "",
        name: "",
        email: "",
        phone: "",
        password: "",
        directory: "صورة المشرف",
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value,
            editError: {
                state: false,
                message: ""
            }
        })
    }

    onImageChange = event => {
        if (event.target.files && event.target.files[0]) {
            this.setState({directory: event.target.value})
            let reader = new FileReader();
            reader.onload = (e) => {
                this.setState({profile_photo: e.target.result})
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    addNewAdmin = e => {
        e.preventDefault();
        const { profile_photo, name, email, phone, password } = this.state;
        this.props.addNewAdmin(profile_photo, name, email, phone, password)
        .then(result => {
            console.log(result);
            if (result.error && result.error !== null) {
                this.setState({
                    addError: {
                        state: true,
                        message: result.error.message
                    }
                })
            } else {
                this.setState({
                    addError: {
                        state: false,
                        message: ""
                    },
                    profile_photo: "",
                    name: "",
                    email: "",
                    phone: "",
                    password: "",
                    directory: "صورة المشرف",
                })
            }
        })
    }
    
    render() {
        const { directory, profile_photo, name, email, phone, password } = this.state;
        return (
            <div className="new-supervisor px-3 py-5">
                <form className="w-100 add-form" onSubmit={this.addNewAdmin}>
                    <div className="add-form__add text-center p-4 w-100 my-4">
                        <FaPlusCircle className="mb-2" color="#fff" size="3rem" />
                        <h5>إضافة {this.props.name} جديد</h5>
                    </div>
                    <div className="add-form__logo-input w-100 my-2">
                        <input type="file" name="profile_photo" className="d-none" id="newsProfile" onChange={this.onImageChange} />
                        <label className="w-100 d-flex justify-content-between" htmlFor="newsProfile">
                            <img className="" src="/icons/photo-camera-interface-symbol-for-button-blue.png" alt="camera" width="30" />
                            <h6 className="mb-0">{directory}</h6>
                            {profile_photo === ""
                                ? <span></span>
                                : <img className="" src={profile_photo} alt="profile" width="30" />
                            }
                        </label>
                    </div>
                    <div className="add-form__text-input w-100 my-2">
                        <input type="text" name="name" value={name} className="w-100 m-0 px-3 py-2" placeholder="اسم المشرف" onChange={this.handleChange} />
                    </div>
                    <div className="add-form__text-input w-100 my-2">
                        <input type="email" name="email" value={email} className="w-100 m-0 px-3 py-2" placeholder="البريد الإلكتروني" onChange={this.handleChange} />
                    </div>
                    <div className="add-form__text-input w-100 my-2">
                        <input type="text" name="phone" value={phone} className="w-100 m-0 px-3 py-2" placeholder="رقم الهاتف" onChange={this.handleChange} />
                    </div>
                    <div className="add-form__text-input w-100 my-2">
                        <input type="text" name="password" value={password} className="w-100 m-0 px-3 py-2" placeholder="كلمة المرور" onChange={this.handleChange} />
                    </div>
                    <div className="alert alert-danger text-center mb-5 fs-5" role="alert" style={{display: this.state.addError.state ? "block" : "none"}}>
                        {this.state.addError.message}
                    </div>
                    <button type="submit" className="px-4 py-2 mx-2 my-4 blue-btn">حفظ</button>
                </form>
            </div>
        )
    }
}

export default NewAdminForm;